// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/sensor/v1/humidity.proto (package msh.trait.sensor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.sensor.v1.HumidityTrait
 */
export const HumidityTrait = proto3.makeMessageType(
  "msh.trait.sensor.v1.HumidityTrait",
  () => [
    { no: 1, name: "humidity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message msh.trait.sensor.v1.HumidityTrait.HumidityChangedEvent
 */
export const HumidityTrait_HumidityChangedEvent = proto3.makeMessageType(
  "msh.trait.sensor.v1.HumidityTrait.HumidityChangedEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "trait", kind: "message", T: HumidityTrait },
    { no: 3, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
  ],
  {localName: "HumidityTrait_HumidityChangedEvent"},
);

